import { IconMessages } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

export const messagingModule: ModuleDefinition = {
  id: 'messaging',
  i18nNamespace: 'messaging',
  requires: { subject: 'thread', action: 'read' },

  nav: {
    labelKey: 'messaging:nav',
    icon: IconMessages,
    to: 'messages',
    group: 'people',
    order: 20,
  },

  routes: [{ path: 'messages', component: () => import('./MessagingPage') }],

  commands: [
    {
      id: 'messaging.inbox',
      labelKey: 'messaging:title',
      groupKey: 'messaging:title',
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/messages`),
    },
  ],
};
